import {
  apiRequest,
  skcp3kList,
  skcp3kActive,
  skcp3kInactive,
  skcp3kDetail,
  skcp3kRankList,
  skcp3kSignatories,
} from "../../../../../services/adapters/kepegawaian/skcp3kService";

class IndexRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skcp3kList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      skcp3kInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      skcp3kActive,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skcp3kDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchRankList = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skcp3kRankList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchSignatories = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skcp3kSignatories,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
